import { productApiClient } from '@/clients/ProductAPIClient';
import { ValidationMetadata } from '@/data/models/validation';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

export default function useGetAlbumValidationMetadataQuery(
  albumId?: string | number | null
): UseQueryResult<ValidationMetadata, Error> {
  return useQuery({
    queryKey: ['albumValidationMetadata', albumId],
    queryFn: async () => {
      const validationMetadataAlbumId = albumId ?? 0;
      const response = await productApiClient.getAlbumValidationMetadata(
        validationMetadataAlbumId.toString()
      );
      return response.data;
    },
    staleTime: Infinity,
  });
}
